import script from "./AssertionList.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssertionList.vue?vue&type=script&setup=true&lang=ts"

import "./AssertionList.vue?vue&type=style&index=0&id=b1af0bea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1af0bea"]])

export default __exports__